export default __webpack_public_path__ + "static/media/6cha.2974a8fa.svg";